export * from '@firebase/firestore';
//# sourceMappingURL=index.esm.js.map
